import { render, staticRenderFns } from "./PrintQuickOp.vue?vue&type=template&id=1ffa2fa9&"
import script from "./PrintQuickOp.vue?vue&type=script&lang=js&"
export * from "./PrintQuickOp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports